import { Route } from '@angular/router';
import { ROOT_ROUTES } from './core/configurations/router';
import { signInGuard } from './core/guards/sign-in.guard';
import { authGuard } from './core/guards/auth.guard';
import { NotFoundComponent } from './shared/components/not-found/not-found.component';
import { transcriptionIdValidationGuard } from './core/guards/transcription-id-validation.guard';
import { ConversationComponent } from './components/conversation/conversation.component';
import {
  conversationDataAnimationName,
  scoreCardDetailsAnimationName,
} from './components/conversation/configurations/conversation-animations.config';
import { StubComponent } from './shared/components/stub/stub.component';
import { scorecardDetailsResolver } from './core/resolvers/scorecard-details.resolver';
import { conversationDataResolver } from './core/resolvers/conversation-data.resolver';
import { reviewViewModeGuard } from './core/guards/review-view-mode.guard';
import { conversationResolver } from './core/resolvers/conversation.resolver';

// https://angular.dev/guide/routing/common-router-tasks#route-order
export const APP_ROUTING: Route[] = [
  {
    path: ROOT_ROUTES.signIn,
    component: StubComponent,
    canMatch: [signInGuard],
  },
  {
    path: ROOT_ROUTES.notFound,
    pathMatch: 'full',
    component: NotFoundComponent,
  },
  {
    path: '',
    canMatch: [authGuard],
    children: [
      {
        path: '',
        component: ConversationComponent,
        canMatch: [transcriptionIdValidationGuard],
        canActivate: [reviewViewModeGuard],
        resolve: [conversationResolver],
        runGuardsAndResolvers: 'paramsOrQueryParamsChange',
        children: [
          {
            path: '',
            pathMatch: 'full',
            redirectTo: ROOT_ROUTES.conversationData,
          },
          {
            path: ROOT_ROUTES.conversationData,
            loadComponent: () =>
              import('./components/conversation-data/conversation-data.component').then(
                (component) => component.ConversationDataComponent,
              ),
            data: { animation: conversationDataAnimationName },
            runGuardsAndResolvers: 'paramsOrQueryParamsChange',
            resolve: [conversationDataResolver],
          },
          {
            path: `${ROOT_ROUTES.agentPerformance}/:id`,
            loadComponent: () =>
              import('./components/agent-performance/agent-performance.component').then(
                (component) => component.AgentPerformanceComponent,
              ),
            data: { animation: scoreCardDetailsAnimationName },
            runGuardsAndResolvers: 'paramsOrQueryParamsChange',
            resolve: [scorecardDetailsResolver],
          },
        ],
      },
    ],
  },
  {
    path: '**',
    redirectTo: ROOT_ROUTES.notFound,
  },
];
